import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

// Language configurations
const LANGUAGE_CONFIG = {
  en: { name: 'English', nativeName: 'English', flag: '🇺🇸', dir: 'ltr' },
  es: { name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', dir: 'ltr' },
  pt: { name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷', dir: 'ltr' },
  ru: { name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', dir: 'ltr' },
  fr: { name: 'French', nativeName: 'Français', flag: '🇫🇷', dir: 'ltr' },
  ar: { name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  zh: { name: 'Chinese', nativeName: '中文', flag: '🇨🇳', dir: 'ltr' },
  hi: { name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳', dir: 'ltr' },
  ur: { name: 'Urdu', nativeName: 'اردو', flag: '🇵🇰', dir: 'rtl' },
  sw: { name: 'Swahili', nativeName: 'Kiswahili', flag: '🇰🇪', dir: 'ltr' }
};

// All translations
const TRANSLATIONS = {
  en: {
  unknownSoldier: "Unknown Soldier",
  alphaMedal: "Alpha Medal of Honour",
  combatPerformance: "Combat Performance",
  kdRatio: "K/D Ratio",
  combatEfficiency: "Combat Efficiency",
  excellentPerformance: "Excellent performance! You dominate the battlefield.",
  keepFighting: "Keep fighting! Your K/D will improve with practice.",
  community: "Community",
  activeSoldiers: "Active Soldiers",
  eliteSquads: "elite squads • Find your battle brothers",
  noClansAvailable: "No clans available",
  databaseEmpty: "Database returned empty result",
  you: "YOU",
  yourCurrentClan: "Your Current Clan",
  backToClans: "Back to Clans",
  noDescription: "No description available.",
  wantToJoin: "Want to join? Connect on WhatsApp",
  alreadyJoined: "Already Joined",
  rank: "Rank:",
  noRank: "No Rank",
  tokens: "Tokens:",
  noClan: "No Clan",
  processing: "Processing...",
  profileNotFound: "Profile not found.",
  unranked: "Unranked",
  unknown: "Unknown",
  noPlayersFound: "No players found matching",
  setupProfile: "Setup Your Profile",
  customizeProfile: "Customize your soldier profile and combat stats",
  uploadFailed: "Upload failed: ",
  avatarUploaded: "Avatar uploaded!",
  enterAvatarName: "Please enter your avatar name",
  errorSaving: "Error saving: ",
  profileSaved: "Profile saved successfully!",
  tapCamera: "Tap camera to upload avatar",
  basicInformation: "Basic Information",
  enterSoldierName: "Enter your soldier name",
  selectRank: "Select Rank",
  selectClan: "Select Clan",
  combatStatistics: "Combat Statistics",
  award: "Award",
  clickClaim: "Click to claim your award",
  saving: "Saving...",
  saveProfile: "Save Profile",
  backToDashboard: "Back to Dashboard",
  remove: "Remove",
  legalInformation: "Legal Information",
  helpSupport: "Help & Support",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "What is WWMMCGC?",
  wwmmcgcDescription: "WWMMCGC (World Wide Mini Militia Classic Global Community) is a global gaming community...",
  ourMission: "Our Mission",
  missionText: "To unite Mini Militia players across the globe...",
  ourVision: "Our Vision",
  visionText: "To become the largest and most organized Mini Militia community platform...",
  switchedTo: "Switched to {mode} mode",
  noUserFound: "No user found",
  accountUpdated: "Account information updated!",
  resetEmailSent: "Reset email sent! Check your inbox.",
  logoutConfirm: "Are you sure you want to logout?",
  loggedOut: "Logged out successfully!",
  deleteWarning: "WARNING: This will permanently delete your account...",
  deleting: "Deleting...",
  accountDeleted: "Account deleted.",
  notSet: "Not set",
  personalInfo: "Personal Information",
  securityAccess: "Security & Access",
  privacyLegal: "Privacy & Legal",
  lastUpdated: "Last Updated",
  learnMore: "Click to learn more →",
  gettingStarted: "Getting Started",
  gettingStartedDesc: "Learn how to create your profile and set up your account",
  followingFollowers: "Following & Followers",
  followingFollowersDesc: "Connect with other soldiers and build your network",
  clansHelp: "Clans",
  clansHelpDesc: "Join or find your clan and team up with others",
  accountSecurity: "Account Security",
  accountSecurityDesc: "Protect your account, reset password, or delete account",
  faq: "Frequently Asked Questions",
  stillNeedHelp: "Still need help?",
  supportTeamReady: "Our support team is ready to assist you with any issues.",
  contactSupportBtn: "Contact Support"
},
  es: {
  unknownSoldier: "Soldado Desconocido",
  alphaMedal: "Medalla Alpha de Honor",
  combatPerformance: "Rendimiento de Combate",
  kdRatio: "Ratio K/D",
  combatEfficiency: "Eficiencia de Combate",
  excellentPerformance: "¡Excelente rendimiento! Dominas el campo de batalla.",
  keepFighting: "¡Sigue luchando! Tu K/D mejorará con la práctica.",
  community: "Comunidad",
  activeSoldiers: "Soldados Activos",
  eliteSquads: "escuadrones de élite • Encuentra tus hermanos de batalla",
  noClansAvailable: "No hay clanes disponibles",
  databaseEmpty: "La base de datos devolvió resultado vacío",
  you: "TÚ",
  yourCurrentClan: "Tu Clan Actual",
  backToClans: "Volver a Clanes",
  noDescription: "No hay descripción disponible.",
  wantToJoin: "¿Quieres unirte? Conecta por WhatsApp",
  alreadyJoined: "Ya Unido",
  rank: "Rango:",
  noRank: "Sin Rango",
  tokens: "Tokens:",
  noClan: "Sin Clan",
  processing: "Procesando...",
  profileNotFound: "Perfil no encontrado.",
  unranked: "Sin Clasificar",
  unknown: "Desconocido",
  noPlayersFound: "No se encontraron jugadores que coincidan",
  setupProfile: "Configura tu Perfil",
  customizeProfile: "Personaliza tu perfil de soldado y estadísticas de combate",
  uploadFailed: "Error al subir: ",
  avatarUploaded: "¡Avatar subido!",
  enterAvatarName: "Por favor ingresa el nombre de tu avatar",
  errorSaving: "Error al guardar: ",
  profileSaved: "¡Perfil guardado exitosamente!",
  tapCamera: "Toca la cámara para subir avatar",
  basicInformation: "Información Básica",
  enterSoldierName: "Ingresa el nombre de tu soldado",
  selectRank: "Seleccionar Rango",
  selectClan: "Seleccionar Clan",
  combatStatistics: "Estadísticas de Combate",
  award: "Premio",
  clickClaim: "Haz clic para reclamar tu premio",
  saving: "Guardando...",
  saveProfile: "Guardar Perfil",
  backToDashboard: "Volver al Panel",
  remove: "Eliminar",
  legalInformation: "Información Legal",
  helpSupport: "Ayuda y Soporte",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "¿Qué es WWMMCGC?",
  wwmmcgcDescription: "WWMMCGC (World Wide Mini Militia Classic Global Community) es una comunidad de juegos global...",
  ourMission: "Nuestra Misión",
  missionText: "Unir a los jugadores de Mini Militia de todo el mundo...",
  ourVision: "Nuestra Visión",
  visionText: "Convertirnos en la plataforma de comunidad de Mini Militia más grande y organizada...",
  switchedTo: "Cambiado a modo {mode}",
  noUserFound: "No se encontró usuario",
  accountUpdated: "¡Información de cuenta actualizada!",
  resetEmailSent: "¡Correo de restablecimiento enviado! Revisa tu bandeja de entrada.",
  logoutConfirm: "¿Estás seguro de que quieres cerrar sesión?",
  loggedOut: "¡Sesión cerrada exitosamente!",
  deleteWarning: "ADVERTENCIA: Esto eliminará permanentemente tu cuenta...",
  deleting: "Eliminando...",
  accountDeleted: "Cuenta eliminada.",
  notSet: "No establecido",
  personalInfo: "Información Personal",
  securityAccess: "Seguridad y Acceso",
  privacyLegal: "Privacidad y Legal",
  lastUpdated: "Última Actualización",
  learnMore: "Haz clic para saber más →",
  gettingStarted: "Primeros Pasos",
  gettingStartedDesc: "Aprende a crear tu perfil y configurar tu cuenta",
  followingFollowers: "Siguiendo y Seguidores",
  followingFollowersDesc: "Conecta con otros soldados y construye tu red",
  clansHelp: "Clanes",
  clansHelpDesc: "Únete o encuentra tu clan y forma equipo con otros",
  accountSecurity: "Seguridad de la Cuenta",
  accountSecurityDesc: "Protege tu cuenta, restablece contraseña o elimina cuenta",
  faq: "Preguntas Frecuentes",
  stillNeedHelp: "¿Aún necesitas ayuda?",
  supportTeamReady: "Nuestro equipo de soporte está listo para ayudarte con cualquier problema.",
  contactSupportBtn: "Contactar Soporte"
},
  pt: {
  unknownSoldier: "Soldado Desconhecido",
  alphaMedal: "Medalha Alpha de Honra",
  combatPerformance: "Desempenho de Combate",
  kdRatio: "Taxa K/D",
  combatEfficiency: "Eficiência de Combate",
  excellentPerformance: "Desempenho excelente! Você domina o campo de batalha.",
  keepFighting: "Continue lutando! Seu K/D melhorará com a prática.",
  community: "Comunidade",
  activeSoldiers: "Soldados Ativos",
  eliteSquads: "esquadrões de elite • Encontre seus irmãos de batalha",
  noClansAvailable: "Nenhum clã disponível",
  databaseEmpty: "O banco de dados retornou resultado vazio",
  you: "VOCÊ",
  yourCurrentClan: "Seu Clã Atual",
  backToClans: "Voltar aos Clãs",
  noDescription: "Nenhuma descrição disponível.",
  wantToJoin: "Quer entrar? Conecte pelo WhatsApp",
  alreadyJoined: "Já Entrou",
  rank: "Rank:",
  noRank: "Sem Rank",
  tokens: "Tokens:",
  noClan: "Sem Clã",
  processing: "Processando...",
  profileNotFound: "Perfil não encontrado.",
  unranked: "Sem Classificação",
  unknown: "Desconhecido",
  noPlayersFound: "Nenhum jogador encontrado correspondente",
  setupProfile: "Configure seu Perfil",
  customizeProfile: "Personalize seu perfil de soldado e estatísticas de combate",
  uploadFailed: "Falha no upload: ",
  avatarUploaded: "Avatar enviado!",
  enterAvatarName: "Por favor digite o nome do seu avatar",
  errorSaving: "Erro ao salvar: ",
  profileSaved: "Perfil salvo com sucesso!",
  tapCamera: "Toque na câmera para enviar avatar",
  basicInformation: "Informações Básicas",
  enterSoldierName: "Digite o nome do seu soldado",
  selectRank: "Selecionar Rank",
  selectClan: "Selecionar Clã",
  combatStatistics: "Estatísticas de Combate",
  award: "Prêmio",
  clickClaim: "Clique para resgatar seu prêmio",
  saving: "Salvando...",
  saveProfile: "Salvar Perfil",
  backToDashboard: "Voltar ao Painel",
  remove: "Remover",
  legalInformation: "Informações Legais",
  helpSupport: "Ajuda e Suporte",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "O que é WWMMCGC?",
  wwmmcgcDescription: "WWMMCGC (World Wide Mini Militia Classic Global Community) é uma comunidade de jogos global...",
  ourMission: "Nossa Missão",
  missionText: "Unir jogadores de Mini Militia em todo o mundo...",
  ourVision: "Nossa Visão",
  visionText: "Tornar-se a maior e mais organizada plataforma de comunidade de Mini Militia...",
  switchedTo: "Mudado para modo {mode}",
  noUserFound: "Nenhum usuário encontrado",
  accountUpdated: "Informações da conta atualizadas!",
  resetEmailSent: "E-mail de redefinição enviado! Verifique sua caixa de entrada.",
  logoutConfirm: "Tem certeza de que deseja sair?",
  loggedOut: "Desconectado com sucesso!",
  deleteWarning: "AVISO: Isso excluirá permanentemente sua conta...",
  deleting: "Excluindo...",
  accountDeleted: "Conta excluída.",
  notSet: "Não definido",
  personalInfo: "Informações Pessoais",
  securityAccess: "Segurança e Acesso",
  privacyLegal: "Privacidade e Legal",
  lastUpdated: "Última Atualização",
  learnMore: "Clique para saber mais →",
  gettingStarted: "Começando",
  gettingStartedDesc: "Aprenda a criar seu perfil e configurar sua conta",
  followingFollowers: "Seguindo e Seguidores",
  followingFollowersDesc: "Conecte-se com outros soldados e construa sua rede",
  clansHelp: "Clãs",
  clansHelpDesc: "Entre ou encontre seu clã e forme equipe com outros",
  accountSecurity: "Segurança da Conta",
  accountSecurityDesc: "Proteja sua conta, redefina senha ou exclua conta",
  faq: "Perguntas Frequentes",
  stillNeedHelp: "Ainda precisa de ajuda?",
  supportTeamReady: "Nossa equipe de suporte está pronta para ajudar com qualquer problema.",
  contactSupportBtn: "Contatar Suporte"
},
  ru: {
  unknownSoldier: "Неизвестный Солдат",
  alphaMedal: "Альфа-Медаль Почёта",
  combatPerformance: "Боевые Показатели",
  kdRatio: "Соотношение K/D",
  combatEfficiency: "Боевая Эффективность",
  excellentPerformance: "Отличная работа! Вы доминируете на поле боя.",
  keepFighting: "Продолжайте сражаться! Ваш K/D улучшится с практикой.",
  community: "Сообщество",
  activeSoldiers: "Активные Солдаты",
  eliteSquads: "элитные отряды • Найди своих боевых братьев",
  noClansAvailable: "Нет доступных кланов",
  databaseEmpty: "База данных вернула пустой результат",
  you: "ВЫ",
  yourCurrentClan: "Ваш Текущий Клан",
  backToClans: "Назад к Кланам",
  noDescription: "Описание отсутствует.",
  wantToJoin: "Хотите присоединиться? Свяжитесь через WhatsApp",
  alreadyJoined: "Уже Присоединился",
  rank: "Ранг:",
  noRank: "Нет Ранга",
  tokens: "Токены:",
  noClan: "Нет Клана",
  processing: "Обработка...",
  profileNotFound: "Профиль не найден.",
  unranked: "Без Ранга",
  unknown: "Неизвестно",
  noPlayersFound: "Игроки не найдены",
  setupProfile: "Настройте Профиль",
  customizeProfile: "Настройте профиль солдата и боевую статистику",
  uploadFailed: "Ошибка загрузки: ",
  avatarUploaded: "Аватар загружен!",
  enterAvatarName: "Пожалуйста, введите имя аватара",
  errorSaving: "Ошибка сохранения: ",
  profileSaved: "Профиль успешно сохранён!",
  tapCamera: "Нажмите на камеру для загрузки аватара",
  basicInformation: "Основная Информация",
  enterSoldierName: "Введите имя солдата",
  selectRank: "Выбрать Ранг",
  selectClan: "Выбрать Клан",
  combatStatistics: "Боевая Статистика",
  award: "Награда",
  clickClaim: "Нажмите, чтобы получить награду",
  saving: "Сохранение...",
  saveProfile: "Сохранить Профиль",
  backToDashboard: "Назад на Панель",
  remove: "Удалить",
  legalInformation: "Юридическая Информация",
  helpSupport: "Помощь и Поддержка",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "Что такое WWMMCGC?",
  wwmmcgcDescription: "WWMMCGC (World Wide Mini Militia Classic Global Community) — глобальное игровое сообщество...",
  ourMission: "Наша Миссия",
  missionText: "Объединить игроков Mini Militia по всему миру...",
  ourVision: "Наше Видение",
  visionText: "Стать крупнейшей и самой организованной платформой сообщества Mini Militia...",
  switchedTo: "Переключено на режим {mode}",
  noUserFound: "Пользователь не найден",
  accountUpdated: "Информация об аккаунте обновлена!",
  resetEmailSent: "Письмо для сброса отправлено! Проверьте входящие.",
  logoutConfirm: "Вы уверены, что хотите выйти?",
  loggedOut: "Успешный выход из системы!",
  deleteWarning: "ВНИМАНИЕ: Это навсегда удалит ваш аккаунт...",
  deleting: "Удаление...",
  accountDeleted: "Аккаунт удалён.",
  notSet: "Не установлено",
  personalInfo: "Личная Информация",
  securityAccess: "Безопасность и Доступ",
  privacyLegal: "Конфиденциальность и Правовая Информация",
  lastUpdated: "Последнее Обновление",
  learnMore: "Нажмите, чтобы узнать больше →",
  gettingStarted: "Начало Работы",
  gettingStartedDesc: "Узнайте, как создать профиль и настроить аккаунт",
  followingFollowers: "Подписки и Подписчики",
  followingFollowersDesc: "Связывайтесь с другими солдатами и стройте свою сеть",
  clansHelp: "Кланы",
  clansHelpDesc: "Присоединяйтесь к клану или найдите свой и объединяйтесь с другими",
  accountSecurity: "Безопасность Аккаунта",
  accountSecurityDesc: "Защитите свой аккаунт, сбросьте пароль или удалите аккаунт",
  faq: "Часто Задаваемые Вопросы",
  stillNeedHelp: "Всё ещё нужна помощь?",
  supportTeamReady: "Наша команда поддержки готова помочь с любыми проблемами.",
  contactSupportBtn: "Связаться с Поддержкой"
},
  fr: {
  unknownSoldier: "Soldat Inconnu",
  alphaMedal: "Médaille Alpha d'Honneur",
  combatPerformance: "Performance de Combat",
  kdRatio: "Ratio K/D",
  combatEfficiency: "Efficacité de Combat",
  excellentPerformance: "Performance excellente ! Vous dominez le champ de bataille.",
  keepFighting: "Continuez à vous battre ! Votre K/D s'améliorera avec la pratique.",
  community: "Communauté",
  activeSoldiers: "Soldats Actifs",
  eliteSquads: "escadrons d'élite • Trouvez vos frères d'armes",
  noClansAvailable: "Aucun clan disponible",
  databaseEmpty: "La base de données a retourné un résultat vide",
  you: "VOUS",
  yourCurrentClan: "Votre Clan Actuel",
  backToClans: "Retour aux Clans",
  noDescription: "Aucune description disponible.",
  wantToJoin: "Vous voulez rejoindre ? Connectez-vous sur WhatsApp",
  alreadyJoined: "Déjà Rejoint",
  rank: "Rang :",
  noRank: "Pas de Rang",
  tokens: "Jetons :",
  noClan: "Pas de Clan",
  processing: "Traitement...",
  profileNotFound: "Profil non trouvé.",
  unranked: "Non Classé",
  unknown: "Inconnu",
  noPlayersFound: "Aucun joueur trouvé correspondant",
  setupProfile: "Configurez votre Profil",
  customizeProfile: "Personnalisez votre profil de soldat et vos statistiques de combat",
  uploadFailed: "Échec du téléchargement : ",
  avatarUploaded: "Avatar téléchargé !",
  enterAvatarName: "Veuillez entrer le nom de votre avatar",
  errorSaving: "Erreur lors de la sauvegarde : ",
  profileSaved: "Profil sauvegardé avec succès !",
  tapCamera: "Touchez l'appareil photo pour télécharger l'avatar",
  basicInformation: "Informations de Base",
  enterSoldierName: "Entrez le nom de votre soldat",
  selectRank: "Sélectionner le Rang",
  selectClan: "Sélectionner le Clan",
  combatStatistics: "Statistiques de Combat",
  award: "Récompense",
  clickClaim: "Cliquez pour réclamer votre récompense",
  saving: "Sauvegarde...",
  saveProfile: "Sauvegarder le Profil",
  backToDashboard: "Retour au Tableau de Bord",
  remove: "Supprimer",
  legalInformation: "Informations Légales",
  helpSupport: "Aide et Support",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "Qu'est-ce que WWMMCGC ?",
  wwmmcgcDescription: "WWMMCGC (World Wide Mini Militia Classic Global Community) est une communauté de jeux mondiale...",
  ourMission: "Notre Mission",
  missionText: "Unir les joueurs de Mini Militia à travers le monde...",
  ourVision: "Notre Vision",
  visionText: "Devenir la plus grande et la plus organisée plateforme communautaire de Mini Militia...",
  switchedTo: "Passé en mode {mode}",
  noUserFound: "Aucun utilisateur trouvé",
  accountUpdated: "Informations du compte mises à jour !",
  resetEmailSent: "E-mail de réinitialisation envoyé ! Vérifiez votre boîte de réception.",
  logoutConfirm: "Êtes-vous sûr de vouloir vous déconnecter ?",
  loggedOut: "Déconnexion réussie !",
  deleteWarning: "AVERTISSEMENT : Cela supprimera définitivement votre compte...",
  deleting: "Suppression...",
  accountDeleted: "Compte supprimé.",
  notSet: "Non défini",
  personalInfo: "Informations Personnelles",
  securityAccess: "Sécurité et Accès",
  privacyLegal: "Confidentialité et Légal",
  lastUpdated: "Dernière Mise à Jour",
  learnMore: "Cliquez pour en savoir plus →",
  gettingStarted: "Premiers Pas",
  gettingStartedDesc: "Apprenez à créer votre profil et configurer votre compte",
  followingFollowers: "Abonnements et Abonnés",
  followingFollowersDesc: "Connectez-vous avec d'autres soldats et construisez votre réseau",
  clansHelp: "Clans",
  clansHelpDesc: "Rejoignez ou trouvez votre clan et faites équipe avec d'autres",
  accountSecurity: "Sécurité du Compte",
  accountSecurityDesc: "Protégez votre compte, réinitialisez le mot de passe ou supprimez le compte",
  faq: "Questions Fréquemment Posées",
  stillNeedHelp: "Encore besoin d'aide ?",
  supportTeamReady: "Notre équipe de support est prête à vous aider avec tous les problèmes.",
  contactSupportBtn: "Contacter le Support"
},
  ar: {
  unknownSoldier: "جندي مجهول",
  alphaMedal: "وسام ألفا للشرف",
  combatPerformance: "أداء القتال",
  kdRatio: "نسبة القتل/الموت",
  combatEfficiency: "كفاءة القتال",
  excellentPerformance: "أداء ممتاز! تهيمن على ساحة المعركة.",
  keepFighting: "استمر في القتال! ستتحسن نسبة K/D الخاصة بك بالممارسة.",
  community: "المجتمع",
  activeSoldiers: "الجنود النشطون",
  eliteSquads: "الفرق النخبة • اعثر على إخوانك في المعركة",
  noClansAvailable: "لا توجد عشائر متاحة",
  databaseEmpty: "قاعدة البيانات أرجعت نتيجة فارغة",
  you: "أنت",
  yourCurrentClan: "عشيرتك الحالية",
  backToClans: "العودة إلى العشائر",
  noDescription: "لا يوجد وصف متاح.",
  wantToJoin: "تريد الانضمام؟ تواصل عبر واتساب",
  alreadyJoined: "انضممت بالفعل",
  rank: "الرتبة:",
  noRank: "لا يوجد رتبة",
  tokens: "الرموز:",
  noClan: "لا يوجد عشيرة",
  processing: "جاري المعالجة...",
  profileNotFound: "لم يتم العثور على الملف الشخصي.",
  unranked: "غير مصنف",
  unknown: "مجهول",
  noPlayersFound: "لم يتم العثور على لاعبين مطابقين",
  setupProfile: "إعداد ملفك الشخصي",
  customizeProfile: "خصص ملف الجندي الخاص بك وإحصائيات القتال",
  uploadFailed: "فشل التحميل: ",
  avatarUploaded: "تم رفع الصورة الرمزية!",
  enterAvatarName: "الرجاء إدخال اسم الصورة الرمزية",
  errorSaving: "خطأ في الحفظ: ",
  profileSaved: "تم حفظ الملف الشخصي بنجاح!",
  tapCamera: "اضغط على الكاميرا لرفع الصورة الرمزية",
  basicInformation: "المعلومات الأساسية",
  enterSoldierName: "أدخل اسم الجندي",
  selectRank: "اختر الرتبة",
  selectClan: "اختر العشيرة",
  combatStatistics: "إحصائيات القتال",
  award: "جائزة",
  clickClaim: "انقر للمطالبة بجائزتك",
  saving: "جاري الحفظ...",
  saveProfile: "حفظ الملف الشخصي",
  backToDashboard: "العودة إلى لوحة التحكم",
  remove: "إزالة",
  legalInformation: "المعلومات القانونية",
  helpSupport: "المساعدة والدعم",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "ما هو WWMMCGC؟",
  wwmmcgcDescription: "WWMMCGC (مجتمع ميني ميليشيا الكلاسيكي العالمي) هو مجتمع ألعاب عالمي...",
  ourMission: "مهمتنا",
  missionText: "توحيد لاعبي ميني ميليشيا حول العالم...",
  ourVision: "رؤيتنا",
  visionText: "أن نصبح أكبر وأكثر منصة مجتمع منظمة لميني ميليشيا...",
  switchedTo: "تم التبديل إلى وضع {mode}",
  noUserFound: "لم يتم العثور على مستخدم",
  accountUpdated: "تم تحديث معلومات الحساب!",
  resetEmailSent: "تم إرسال بريد إعادة التعيين! تحقق من صندوق الوارد.",
  logoutConfirm: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
  loggedOut: "تم تسجيل الخروج بنجاح!",
  deleteWarning: "تحذير: سيؤدي هذا إلى حذف حسابك نهائيًا...",
  deleting: "جاري الحذف...",
  accountDeleted: "تم حذف الحساب.",
  notSet: "غير محدد",
  personalInfo: "المعلومات الشخصية",
  securityAccess: "الأمان والوصول",
  privacyLegal: "الخصوصية والقانون",
  lastUpdated: "آخر تحديث",
  learnMore: "انقر لمعرفة المزيد →",
  gettingStarted: "البدء",
  gettingStartedDesc: "تعلم كيفية إنشاء ملفك الشخصي وإعداد حسابك",
  followingFollowers: "المتابَعون والمتابِعون",
  followingFollowersDesc: "تواصل مع جنود آخرين وابنِ شبكتك",
  clansHelp: "العشائر",
  clansHelpDesc: "انضم أو اعثر على عشيرتك وشكّل فريقًا مع الآخرين",
  accountSecurity: "أمان الحساب",
  accountSecurityDesc: "حمِ حسابك، أعد تعيين كلمة المرور، أو احذف الحساب",
  faq: "الأسئلة الشائعة",
  stillNeedHelp: "هل ما زلت بحاجة للمساعدة؟",
  supportTeamReady: "فريق الدعم لدينا جاهز لمساعدتك في أي مشاكل.",
  contactSupportBtn: "التواصل مع الدعم"
},
  zh: {
  unknownSoldier: "未知士兵",
  alphaMedal: "阿尔法荣誉勋章",
  combatPerformance: "战斗表现",
  kdRatio: "K/D 比率",
  combatEfficiency: "战斗效率",
  excellentPerformance: "表现优异！你主宰了战场。",
  keepFighting: "继续战斗！你的 K/D 会随着练习提高。",
  community: "社区",
  activeSoldiers: "活跃士兵",
  eliteSquads: "精英小队 • 寻找你的战斗兄弟",
  noClansAvailable: "没有可用的战队",
  databaseEmpty: "数据库返回空结果",
  you: "你",
  yourCurrentClan: "你当前的战队",
  backToClans: "返回战队",
  noDescription: "暂无描述。",
  wantToJoin: "想加入？通过 WhatsApp 联系",
  alreadyJoined: "已加入",
  rank: "等级：",
  noRank: "无等级",
  tokens: "代币：",
  noClan: "无战队",
  processing: "处理中...",
  profileNotFound: "未找到个人资料。",
  unranked: "未排名",
  unknown: "未知",
  noPlayersFound: "未找到匹配的玩家",
  setupProfile: "设置你的个人资料",
  customizeProfile: "自定义你的士兵资料和战斗数据",
  uploadFailed: "上传失败：",
  avatarUploaded: "头像已上传！",
  enterAvatarName: "请输入你的头像名称",
  errorSaving: "保存错误：",
  profileSaved: "个人资料保存成功！",
  tapCamera: "点击相机上传头像",
  basicInformation: "基本信息",
  enterSoldierName: "输入你的士兵名称",
  selectRank: "选择等级",
  selectClan: "选择战队",
  combatStatistics: "战斗统计",
  award: "奖励",
  clickClaim: "点击领取你的奖励",
  saving: "保存中...",
  saveProfile: "保存个人资料",
  backToDashboard: "返回仪表板",
  remove: "移除",
  legalInformation: "法律信息",
  helpSupport: "帮助与支持",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "什么是 WWMMCGC？",
  wwmmcgcDescription: "WWMMCGC（全球迷你民兵经典社区）是一个全球游戏社区...",
  ourMission: "我们的使命",
  missionText: "团结全球的迷你民兵玩家...",
  ourVision: "我们的愿景",
  visionText: "成为最大、最有组织的迷你民兵社区平台...",
  switchedTo: "已切换到 {mode} 模式",
  noUserFound: "未找到用户",
  accountUpdated: "账户信息已更新！",
  resetEmailSent: "重置邮件已发送！请检查收件箱。",
  logoutConfirm: "确定要退出登录吗？",
  loggedOut: "退出登录成功！",
  deleteWarning: "警告：这将永久删除你的账户...",
  deleting: "删除中...",
  accountDeleted: "账户已删除。",
  notSet: "未设置",
  personalInfo: "个人信息",
  securityAccess: "安全与访问",
  privacyLegal: "隐私与法律",
  lastUpdated: "最后更新",
  learnMore: "点击了解更多 →",
  gettingStarted: "入门指南",
  gettingStartedDesc: "了解如何创建个人资料和设置账户",
  followingFollowers: "关注与粉丝",
  followingFollowersDesc: "与其他士兵联系并建立你的网络",
  clansHelp: "战队",
  clansHelpDesc: "加入或寻找你的战队，与他人组队",
  accountSecurity: "账户安全",
  accountSecurityDesc: "保护你的账户、重置密码或删除账户",
  faq: "常见问题",
  stillNeedHelp: "还需要帮助？",
  supportTeamReady: "我们的支持团队随时准备协助你解决任何问题。",
  contactSupportBtn: "联系支持"
},
  hi: {
  unknownSoldier: "अज्ञात सैनिक",
  alphaMedal: "अल्फा सम्मान पदक",
  combatPerformance: "युद्ध प्रदर्शन",
  kdRatio: "K/D अनुपात",
  combatEfficiency: "युद्ध क्षमता",
  excellentPerformance: "उत्कृष्ट प्रदर्शन! आप युद्धभूमि पर हावी हैं।",
  keepFighting: "लड़ते रहें! अभ्यास से आपका K/D सुधरेगा।",
  community: "समुदाय",
  activeSoldiers: "सक्रिय सैनिक",
  eliteSquads: "एलीट दस्ते • अपने युद्ध भाइयों को खोजें",
  noClansAvailable: "कोई क्लैन उपलब्ध नहीं",
  databaseEmpty: "डेटाबेस ने खाली परिणाम दिया",
  you: "आप",
  yourCurrentClan: "आपका वर्तमान क्लैन",
  backToClans: "क्लैन पर वापस जाएं",
  noDescription: "कोई विवरण उपलब्ध नहीं।",
  wantToJoin: "शामिल होना चाहते हैं? WhatsApp पर जुड़ें",
  alreadyJoined: "पहले से जुड़े हुए",
  rank: "रैंक:",
  noRank: "कोई रैंक नहीं",
  tokens: "टोकन:",
  noClan: "कोई क्लैन नहीं",
  processing: "प्रोसेसिंग...",
  profileNotFound: "प्रोफाइल नहीं मिली।",
  unranked: "अवर्गीकृत",
  unknown: "अज्ञात",
  noPlayersFound: "कोई खिलाड़ी नहीं मिला",
  setupProfile: "अपनी प्रोफाइल सेटअप करें",
  customizeProfile: "अपने सैनिक प्रोफाइल और युद्ध आंकड़े अनुकूलित करें",
  uploadFailed: "अपलोड विफल: ",
  avatarUploaded: "अवतार अपलोड हो गया!",
  enterAvatarName: "कृपया अपना अवतार नाम दर्ज करें",
  errorSaving: "सेव करने में त्रुटि: ",
  profileSaved: "प्रोफाइल सफलतापूर्वक सेव हो गई!",
  tapCamera: "अवतार अपलोड करने के लिए कैमरा पर टैप करें",
  basicInformation: "बुनियादी जानकारी",
  enterSoldierName: "अपना सैनिक नाम दर्ज करें",
  selectRank: "रैंक चुनें",
  selectClan: "क्लैन चुनें",
  combatStatistics: "युद्ध आंकड़े",
  award: "पुरस्कार",
  clickClaim: "अपना पुरस्कार दावा करने के लिए क्लिक करें",
  saving: "सेव हो रहा है...",
  saveProfile: "प्रोफाइल सेव करें",
  backToDashboard: "डैशबोर्ड पर वापस जाएं",
  remove: "हटाएं",
  legalInformation: "कानूनी जानकारी",
  helpSupport: "सहायता और समर्थन",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "WWMMCGC क्या है?",
  wwmmcgcDescription: "WWMMCGC (वर्ल्ड वाइड मिनी मिलिशिया क्लासिक ग्लोबल कम्युनिटी) एक वैश्विक गेमिंग समुदाय है...",
  ourMission: "हमारा मिशन",
  missionText: "दुनिया भर के मिनी मिलिशिया खिलाड़ियों को एकजुट करना...",
  ourVision: "हमारा दृष्टिकोण",
  visionText: "सबसे बड़ा और सबसे संगठित मिनी मिलिशिया समुदाय प्लेटफॉर्म बनना...",
  switchedTo: "{mode} मोड में स्विच किया गया",
  noUserFound: "कोई उपयोगकर्ता नहीं मिला",
  accountUpdated: "खाता जानकारी अपडेट हो गई!",
  resetEmailSent: "रीसेट ईमेल भेज दिया गया! अपना इनबॉक्स जांचें।",
  logoutConfirm: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
  loggedOut: "सफलतापूर्वक लॉग आउट हो गया!",
  deleteWarning: "चेतावनी: इससे आपका खाता स्थायी रूप से हट जाएगा...",
  deleting: "हटाया जा रहा है...",
  accountDeleted: "खाता हटा दिया गया।",
  notSet: "सेट नहीं",
  personalInfo: "व्यक्तिगत जानकारी",
  securityAccess: "सुरक्षा और पहुंच",
  privacyLegal: "गोपनीयता और कानूनी",
  lastUpdated: "अंतिम अपडेट",
  learnMore: "और जानने के लिए क्लिक करें →",
  gettingStarted: "शुरुआत करना",
  gettingStartedDesc: "अपनी प्रोफाइल बनाना और खाता सेटअप करना सीखें",
  followingFollowers: "फॉलोइंग और फॉलोअर्स",
  followingFollowersDesc: "अन्य सैनिकों से जुड़ें और अपना नेटवर्क बनाएं",
  clansHelp: "क्लैन",
  clansHelpDesc: "अपने क्लैन में शामिल हों या खोजें और दूसरों के साथ टीम बनाएं",
  accountSecurity: "खाता सुरक्षा",
  accountSecurityDesc: "अपने खाते की सुरक्षा करें, पासवर्ड रीसेट करें, या खाता हटाएं",
  faq: "अक्सर पूछे जाने वाले प्रश्न",
  stillNeedHelp: "अभी भी मदद चाहिए?",
  supportTeamReady: "हमारी सहायता टीम किसी भी समस्या में आपकी सहायता के लिए तैयार है।",
  contactSupportBtn: "सहायता से संपर्क करें"
},
  ur: {
  unknownSoldier: "نامعلوم سپاہی",
  alphaMedal: "الفا اعزاز تمغہ",
  combatPerformance: "لڑائی کارکردگی",
  kdRatio: "K/D تناسب",
  combatEfficiency: "لڑائی کی کارکردگی",
  excellentPerformance: "بہترین کارکردگی! آپ میدان جنگ پر غالب ہیں۔",
  keepFighting: "لڑتے رہیں! مشق سے آپ کا K/D بہتر ہوگا۔",
  community: "کمیونٹی",
  activeSoldiers: "فعال سپاہی",
  eliteSquads: "انتہائی دستے • اپنے جنگ بھائیوں کو تلاش کریں",
  noClansAvailable: "کوئی کلب دستیاب نہیں",
  databaseEmpty: "ڈیٹا بیس نے خالی نتیجہ دیا",
  you: "آپ",
  yourCurrentClan: "آپ کا موجودہ کلب",
  backToClans: "کلب پر واپس جائیں",
  noDescription: "کوئی تفصیل دستیاب نہیں۔",
  wantToJoin: "شامل ہونا چاہتے ہیں؟ WhatsApp پر رابطہ کریں",
  alreadyJoined: "پہلے ہی شامل ہو چکے",
  rank: "رینک:",
  noRank: "کوئی رینک نہیں",
  tokens: "ٹوکن:",
  noClan: "کوئی کلب نہیں",
  processing: "پروسیسنگ...",
  profileNotFound: "پروفائل نہیں ملی۔",
  unranked: "غیر درجہ بند",
  unknown: "نامعلوم",
  noPlayersFound: "کوئی کھلاڑی نہیں ملا",
  setupProfile: "اپنی پروفائل سیٹ اپ کریں",
  customizeProfile: "اپنے سپاہی پروفائل اور لڑائی کے اعداد و شمار کو حسب ضرورت بنائیں",
  uploadFailed: "اپلوڈ ناکام: ",
  avatarUploaded: "اوتار اپلوڈ ہو گیا!",
  enterAvatarName: "براہ کرم اپنا اوتار نام درج کریں",
  errorSaving: "محفوظ کرنے میں خرابی: ",
  profileSaved: "پروفائل کامیابی سے محفوظ ہو گئی!",
  tapCamera: "اوتار اپلوڈ کرنے کے لیے کیمرہ پر ٹیپ کریں",
  basicInformation: "بنیادی معلومات",
  enterSoldierName: "اپنا سپاہی نام درج کریں",
  selectRank: "رینک منتخب کریں",
  selectClan: "کلب منتخب کریں",
  combatStatistics: "لڑائی کے اعداد و شمار",
  award: "ایوارڈ",
  clickClaim: "اپنا ایوارڈ حاصل کرنے کے لیے کلک کریں",
  saving: "محفوظ ہو رہا ہے...",
  saveProfile: "پروفائل محفوظ کریں",
  backToDashboard: "ڈیش بورڈ پر واپس جائیں",
  remove: "ہٹائیں",
  legalInformation: "قانونی معلومات",
  helpSupport: "مدد اور سپورٹ",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "WWMMCGC کیا ہے؟",
  wwmmcgcDescription: "WWMMCGC (ورلڈ وائڈ منی ملیشیا کلاسک گلوبل کمیونٹی) ایک عالمی گیمنگ کمیونٹی ہے...",
  ourMission: "ہمارا مشن",
  missionText: "دنیا بھر کے منی ملیشیا کھلاڑیوں کو متحد کرنا...",
  ourVision: "ہمارا وژن",
  visionText: "سب سے بڑی اور سب سے منظم منی ملیشیا کمیونٹی پلیٹ فارم بننا...",
  switchedTo: "{mode} موڈ پر سوئچ ہو گیا",
  noUserFound: "کوئی صارف نہیں ملا",
  accountUpdated: "اکاؤنٹ کی معلومات اپ ڈیٹ ہو گئی!",
  resetEmailSent: "ری سیٹ ای میل بھیج دی گئی! اپنا ان باکس چیک کریں۔",
  logoutConfirm: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
  loggedOut: "کامیابی سے لاگ آؤٹ ہو گیا!",
  deleteWarning: "انتباہ: یہ آپ کا اکاؤنٹ مستقل طور پر حذف کر دے گا...",
  deleting: "حذف ہو رہا ہے...",
  accountDeleted: "اکاؤنٹ حذف کر دیا گیا۔",
  notSet: "سیٹ نہیں",
  personalInfo: "ذاتی معلومات",
  securityAccess: "سیکیورٹی اور رسائی",
  privacyLegal: "رازداری اور قانونی",
  lastUpdated: "آخری اپ ڈیٹ",
  learnMore: "مزید جاننے کے لیے کلک کریں →",
  gettingStarted: "شروعات",
  gettingStartedDesc: "اپنی پروفائل بنانا اور اپنا اکاؤنٹ سیٹ اپ کرنا سیکھیں",
  followingFollowers: "فالوئنگ اور فالوورز",
  followingFollowersDesc: "دیگر سپاہیوں سے رابطہ کریں اور اپنا نیٹ ورک بنائیں",
  clansHelp: "کلب",
  clansHelpDesc: "اپنے کلب میں شامل ہوں یا تلاش کریں اور دوسروں کے ساتھ ٹیم بنائیں",
  accountSecurity: "اکاؤنٹ سیکیورٹی",
  accountSecurityDesc: "اپنے اکاؤنٹ کی حفاظت کریں، پاس ورڈ ری سیٹ کریں، یا اکاؤنٹ حذف کریں",
  faq: "اکثر پوچھے جانے والے سوالات",
  stillNeedHelp: "ابھی بھی مدد چاہیے؟",
  supportTeamReady: "ہماری سپورٹ ٹیم کسی بھی مسئلے میں آپ کی مدد کے لیے تیار ہے۔",
  contactSupportBtn: "سپورٹ سے رابطہ کریں"
},
  sw: {
  unknownSoldier: "Askari Asiyejulikana",
  alphaMedal: "Medali ya Alpha ya Heshima",
  combatPerformance: "Utendaji wa Mapigano",
  kdRatio: "Uwiano wa K/D",
  combatEfficiency: "Ufanisi wa Mapigano",
  excellentPerformance: "Utendaji bora! Unatawala uwanja wa mapigano.",
  keepFighting: "Endelea kupigana! K/D yako itaboreka kwa mazoezi.",
  community: "Jumuiya",
  activeSoldiers: "Askari Hai",
  eliteSquads: "vikosi bora • Tafuta ndugu zako wa mapigano",
  noClansAvailable: "Hakuna maklan yanayopatikana",
  databaseEmpty: "Hifadhidata imerejesha matokeo tupu",
  you: "WEWE",
  yourCurrentClan: "Klan Yako ya Sasa",
  backToClans: "Rudi kwa Maklan",
  noDescription: "Hakuna maelezo yanayopatikana.",
  wantToJoin: "Unataka kujiunga? Wasiliana kupitia WhatsApp",
  alreadyJoined: "Tayari Umejiunga",
  rank: "Cheo:",
  noRank: "Hakuna Cheo",
  tokens: "Ishara:",
  noClan: "Hakuna Klan",
  processing: "Inachakata...",
  profileNotFound: "Wasifu haukupatikana.",
  unranked: "Haijopangwa",
  unknown: "Haijulikani",
  noPlayersFound: "Hakuna wachezaji waliopatikana",
  setupProfile: "Sanidi Wasifu Wako",
  customizeProfile: "Binafsisha wasifu wako wa askari na takwimu za mapigano",
  uploadFailed: "Upakiaji umeshindwa: ",
  avatarUploaded: "Avatar imepakiwa!",
  enterAvatarName: "Tafadhali ingiza jina la avatar yako",
  errorSaving: "Hitilafu katika kuhifadhi: ",
  profileSaved: "Wasifu umehifadhiwa kwa mafanikio!",
  tapCamera: "Gusa kamera kupakia avatar",
  basicInformation: "Taarifa za Msingi",
  enterSoldierName: "Ingiza jina lako la askari",
  selectRank: "Chagua Cheo",
  selectClan: "Chagua Klan",
  combatStatistics: "Takwimu za Mapigano",
  award: "Tuzo",
  clickClaim: "Bonyeza kudai tuzo yako",
  saving: "Inahifadhi...",
  saveProfile: "Hifadhi Wasifu",
  backToDashboard: "Rudi kwa Dashibodi",
  remove: "Ondoa",
  legalInformation: "Taarifa za Kisheria",
  helpSupport: "Msaada na Usaidizi",
  contactAt: "support@wwmmcgc.com",
  whatIsWwmmcgc: "WWMMCGC ni nini?",
  wwmmcgcDescription: "WWMMCGC (World Wide Mini Militia Classic Global Community) ni jumuiya ya michezo duniani...",
  ourMission: "Dhim yetu",
  missionText: "Kuungana wachezaji wa Mini Militia kote duniani...",
  ourVision: "Dira yetu",
  visionText: "Kuwa jukwaa kubwa zaidi na lililoandaliwa zaidi la jumuiya ya Mini Militia...",
  switchedTo: "Imebadilishwa kwa hali ya {mode}",
  noUserFound: "Hakuna mtumiaji aliyepatikana",
  accountUpdated: "Taarifa za akaunti zimesasishwa!",
  resetEmailSent: "Barua pepe ya kuweka upya imetumwa! Angalia kikasha chako.",
  logoutConfirm: "Una uhakika unataka kutoka?",
  loggedOut: "Kutoka kwa mafanikio!",
  deleteWarning: "ONYO: Hii itafuta akaunti yako kabisa...",
  deleting: "Inafuta...",
  accountDeleted: "Akaunti imefutwa.",
  notSet: "Haijawekwa",
  personalInfo: "Taarifa Binafsi",
  securityAccess: "Usalama na Ufikiaji",
  privacyLegal: "Faragha na Kisheria",
  lastUpdated: "Mwisho Kusasishwa",
  learnMore: "Bonyeza kujifunza zaidi →",
  gettingStarted: "Kuanza",
  gettingStartedDesc: "Jifunze jinsi ya kuunda wasifu wako na kusanidi akaunti yako",
  followingFollowers: "Kufuatilia na Wanaofuatilia",
  followingFollowersDesc: "Ungana na askari wengine ujenge mtandao wako",
  clansHelp: "Maklan",
  clansHelpDesc: "Jiunge au tafuta klan yako na shirikiana na wengine",
  accountSecurity: "Usalama wa Akaunti",
  accountSecurityDesc: "Linda akaunti yako, weka upya nenosiri, au futa akaunti",
  faq: "Maswali Yanayoulizwa Mara kwa Mara",
  stillNeedHelp: "Bado unahitaji msaada?",
  supportTeamReady: "Timu yetu ya usaidizi iko tayari kukusaidia na masuala yoyote.",
  contactSupportBtn: "Wasiliana na Usaidizi"
}
};

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(
    localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    const langConfig = LANGUAGE_CONFIG[language];
    if (langConfig) {
      document.documentElement.dir = langConfig.dir;
      document.documentElement.lang = language;
    }
    localStorage.setItem("language", language);
  }, [language]);

  const setLanguage = (langCode) => {
    if (LANGUAGE_CONFIG[langCode]) {
      setLanguageState(langCode);
    }
  };

  const t = (key) => {
    return TRANSLATIONS[language]?.[key] || TRANSLATIONS['en']?.[key] || key;
  };

  const getLanguageConfig = () => LANGUAGE_CONFIG[language] || LANGUAGE_CONFIG['en'];

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      t,
      getLanguageConfig,
      availableLanguages: LANGUAGE_CONFIG 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;